var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dflex",class:_vm.$style.wrapper},[_c('div',{class:_vm.$style.icon},[_vm._t("icon",[_c('b-icon',{attrs:{"icon":"plug","alt":"Иконка 'информация'"}})])],2),_c('div',{class:_vm.$style.text},[_vm._t("text")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }